import { httpClient } from "@/services";
import requestKeys from "@/constants/requestKeys";
import trucksHeaders from "@/pages/Maintenance/Trucks/trucksHeaders";

export default {
	state: {
		trucksItem: null,
		trucksList: null,
		trucksFilters: null,
		trucksTotals: null,
		trucksLimit: null,
		trucksOrder: null,
		trucksSort: null,
		trucksTotal: null,
	},
	mutations: {
		updateTrucksList(state, { rows, limit, order, sort, total }) {
			state.trucksList = rows;
			state.trucksLimit = limit;
			state.trucksOrder = order;
			state.trucksSort = sort;
			state.trucksTotal = total;
			state.trucksTotals = { id: total };
		},
		updateTrucksFilters(state, { filter }) {
			state.trucksFilters = filter;
		},
		updateTrucks(state, payload) {
			state.trucksItem = payload;
		}
	},

	actions: {

		async getTrucks({ commit, dispatch }, values) {
			dispatch("actionPreloader", true);
			try {
				const { data } = await httpClient.post('/trucks/list', values);

				if (data && !data.status) {
					commit('updateTrucksList', data);
					commit('updateSettings', { settings: data.settings, key: requestKeys.TRUCKS, defaultHeader: trucksHeaders });
				}
			} catch (error) {
				console.error(error);
			} finally {
				dispatch("actionPreloader", false);
			}
		},

		async getTrucksFilters({ commit }, values) {
			try {
				const { data } = await httpClient.post('/trucks/filters', values);
				if (data) commit('updateTrucksFilters', data);
			} catch (e) {
				console.error(e);
			}
		},

		async onTrucksCreate({ commit, dispatch }, id) {
			dispatch("actionPreloader", true);
			const url = id ? `/trucks/create?customer_id=${ id }` : "/trucks/create";
			try {
				const { data } = await httpClient.get(url);
				if (data && !data.error) {
					if (id) {
						return data;
					}
					commit('updateTrucks', data);
				}
			} catch (e) {
				console.error(e);
			} finally {
				dispatch("actionPreloader", false);
			}
		},

		async onTrucksHistory({ dispatch }, history) {
			dispatch("actionPreloader", true);
			try {
				await httpClient.post('/trucks/updateTruckCustomer', { history });
			} catch (e) {
				console.error(e);
			} finally {
				dispatch("actionPreloader", false);
			}
		},

		async onTrucksSave({ dispatch }, { values, truckId }) {
			dispatch("actionPreloader", true);
			const typeOfRequest = truckId ? 'put' : 'post';
			const url = truckId ? `/trucks/${ truckId }` : '/trucks';
			try {
				const { data } = await httpClient[typeOfRequest](url, values);
				if (data) {
					return data;
				}
			} catch (e) {
				console.error(e);
			} finally {
				dispatch("actionPreloader", false);
			}
		},

		async onTrucksEdit({ commit, dispatch }, id) {
			dispatch("actionPreloader", true);
			try {
				const { data } = await httpClient.get(`/trucks/${ id }/edit`);

				if (data && !data.error) {
					commit('updateTrucks', data);
				}
			} catch (e) {
				console.error(e);
			} finally {
				dispatch("actionPreloader", false);
			}
		},
		async onTrucksRemoveItem({ dispatch }, id) {
			try {
				const { data } = await httpClient.delete(`/trucks/${ id }`);
				if (data.status) {
					dispatch('setAlert', { type: "success", message: "The removal was successful" });
				} else {
					dispatch('setAlert', { type: "error", message: "Deletion error" });
				}

				return data;
			} catch (e) {
				console.error(e);
			}
		}
	},
	getters: {
		trucksItem: (s) => s.trucksItem,
		trucksList: (s) => s.trucksList,
		trucksFilters: (s) => s.trucksFilters,
		trucksTotals: (s) => s.trucksTotals,
		trucksLimit: (s) => s.trucksLimit,
		trucksOrder: (s) => s.trucksOrder,
		trucksSort: (s) => s.trucksSort,
		trucksTotal: (s) => s.trucksTotal,
	}
};
